import React from "react";
import Page from "./Page";

const NotFound = () => {
  return (
    <Page title="Not found">
      <h2>Page not found</h2>
    </Page>
  );
};

export default NotFound;
